// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smartInventoryReportingSectionMarginTop {
  margin-top: 105px;
}
.smartInventoryReportingSystemHeading {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 60px;
  color: #333333;
}
@media only screen and (max-width: 767.98px) {
  .smartInventoryReportingSystemHeading {
    color: #333333;
    font-family: "Roboto";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 60px;
    margin-top: -70px;
    margin-bottom: -24px;
  }
}

.smartInventoryReportingHeadingLatter {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 60px;
  color: #548dff;
}
@media only screen and (max-width: 767.98px) {
  .smartInventoryReportingHeadingLatter {
    color: #548dff;
    font-family: "Roboto";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 60px;
  }
}

.reportMannagmentItemsGrid {
  margin-top: 14px;
}
@media only screen and (max-width: 767.98px) {
  .reportMannagmentItemsGrid {
    margin-top: 16px !important;
  }
}

.reportMannagmentItemsTopMargin {
  margin-top: 40px;
}
@media only screen and (max-width: 767.98px) {
  .reportMannagmentItemsTopMargin {
    margin-top: 7px;
  }
}

.reportMannagmentItemIcon {
  width: 64px;
  height: 64px;
}
@media only screen and (max-width: 767.98px) {
  .reportMannagmentItemIcon {
    width: 30px;
    height: 29.774px;
  }
}

.smartInventoryReportingPara {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  color: #333330;
  margin-top: 26px;
}
@media only screen and (max-width: 767.98px) {
  .smartInventoryReportingPara {
    color: #333330;
    font-family: "Roboto";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    padding-bottom: 10px !important;
  }
}

.smartInventoryReportingItemName {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #333333;
}
@media only screen and (max-width: 767.98px) {
  .smartInventoryReportingItemName {
    color: #333;
    font-family: "Roboto";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}

.smartInventoryReportingDescription {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  margin-top: 21px;
  color: #666666;
}
@media only screen and (max-width: 767.98px) {
  .smartInventoryReportingDescription {
    color: #666;
    font-family: "Roboto";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: 2px;
    margin-bottom: 20px;
  }
  .learnMoreBtnAI {
    margin-top: 10px;
    margin-bottom: 20px;
  }
}

.learnButtonButtonBoxForsmartInventoryReportingItems {
  width: 177px;
  height: 56px;
  border-radius: 4px;
  background-color: #4d30ff;
  border: 1px solid white;
}

.learnButtonCoustomTextInventoryReporting {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */

  text-align: center;

  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/Inventory/components/SmartInventoryReporting/SmartInventoryReporting.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;EACjC;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,kBAAkB;;EAElB,YAAY;AACd","sourcesContent":[".smartInventoryReportingSectionMarginTop {\n  margin-top: 105px;\n}\n.smartInventoryReportingSystemHeading {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 60px;\n  color: #333333;\n}\n@media only screen and (max-width: 767.98px) {\n  .smartInventoryReportingSystemHeading {\n    color: #333333;\n    font-family: \"Roboto\";\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 60px;\n    margin-top: -70px;\n    margin-bottom: -24px;\n  }\n}\n\n.smartInventoryReportingHeadingLatter {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 60px;\n  color: #548dff;\n}\n@media only screen and (max-width: 767.98px) {\n  .smartInventoryReportingHeadingLatter {\n    color: #548dff;\n    font-family: \"Roboto\";\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 60px;\n  }\n}\n\n.reportMannagmentItemsGrid {\n  margin-top: 14px;\n}\n@media only screen and (max-width: 767.98px) {\n  .reportMannagmentItemsGrid {\n    margin-top: 16px !important;\n  }\n}\n\n.reportMannagmentItemsTopMargin {\n  margin-top: 40px;\n}\n@media only screen and (max-width: 767.98px) {\n  .reportMannagmentItemsTopMargin {\n    margin-top: 7px;\n  }\n}\n\n.reportMannagmentItemIcon {\n  width: 64px;\n  height: 64px;\n}\n@media only screen and (max-width: 767.98px) {\n  .reportMannagmentItemIcon {\n    width: 30px;\n    height: 29.774px;\n  }\n}\n\n.smartInventoryReportingPara {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 32px;\n  color: #333330;\n  margin-top: 26px;\n}\n@media only screen and (max-width: 767.98px) {\n  .smartInventoryReportingPara {\n    color: #333330;\n    font-family: \"Roboto\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    padding-bottom: 10px !important;\n  }\n}\n\n.smartInventoryReportingItemName {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 23px;\n  color: #333333;\n}\n@media only screen and (max-width: 767.98px) {\n  .smartInventoryReportingItemName {\n    color: #333;\n    font-family: \"Roboto\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n}\n\n.smartInventoryReportingDescription {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 25px;\n  margin-top: 21px;\n  color: #666666;\n}\n@media only screen and (max-width: 767.98px) {\n  .smartInventoryReportingDescription {\n    color: #666;\n    font-family: \"Roboto\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    margin-top: 2px;\n    margin-bottom: 20px;\n  }\n  .learnMoreBtnAI {\n    margin-top: 10px;\n    margin-bottom: 20px;\n  }\n}\n\n.learnButtonButtonBoxForsmartInventoryReportingItems {\n  width: 177px;\n  height: 56px;\n  border-radius: 4px;\n  background-color: #4d30ff;\n  border: 1px solid white;\n}\n\n.learnButtonCoustomTextInventoryReporting {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  /* identical to box height */\n\n  text-align: center;\n\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
